import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../Styles/Mocktest.css";

import { AiOutlineSearch } from "@react-icons/all-files/ai/AiOutlineSearch";

import { Link } from "react-router-dom";

function Mocktest() {
  return (
    <div className="Mocktest_wrapper">
      <div className="col-md-12">
        <h5>Mock test</h5>
      </div>
      <div className="Mocktest_wrapper_table">
        <div className="col-md-12">
          <form className="d-flex Searchbar">
            <div className="serch-icon">
              <AiOutlineSearch />
            </div>
            <input
              className="form-control "
              type="search"
              aria-label="Search"
              placeholder="Examboard"
            />
            <div className="serch-icon">
              <AiOutlineSearch />
            </div>
            <input
              className="form-control "
              type="search"
              aria-label="Search"
              placeholder="Grade"
            />
            <div className="serch-icon">
              <AiOutlineSearch />
            </div>
            <input
              className="form-control "
              type="search"
              aria-label="Search"
              placeholder="Subject"
            />
            <div className="serch-icon">
              <AiOutlineSearch />
            </div>
            <input
              className="form-control "
              type="search"
              aria-label="Search"
              placeholder="Chapter"
            />
          </form>
          <div className="Mocktest_table">
            <table className="table" id="Mocktest_table">
              <tr>
                <th></th>
                <th>Chapter Name</th>
                <th>Subject</th>
                <th>Grade</th>
                <th>Exam board</th>
                <th>Mock 1</th>
                <th>Mock 2</th>
                <th>Mock 3</th>
              </tr>
              <tr>
                <td id="Mocktest_Color">
                  {/* <span>S</span> */}
                  <img src=""alt=""/>
                </td>
                <td>01. The particle models</td>
                <td>
                  <span id="mocktestsubject">Chemistry</span>
                </td>
                <td>G3</td>
                <td>AQA</td>
                <td id="Chapterpaper_button">
                  <Link to="/activitymocktestbuttona">
                    <button>Create</button>
                  </Link>
                </td>
                <td id="Chapterpaper_button">
                  <Link to="/activitymocktestbuttonb">
                    <button>Create</button>
                  </Link>
                </td>
                <td id="Chapterpaper_button">
                  <Link to="/activitymocktestbuttonc">
                    <button>Create</button>
                  </Link>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mocktest;
